import { api } from "~/api";
import { defineComponent, toRefs, reactive } from "vue";
import { useRouter } from "vue-router";
import { MsgBox } from "~/components/MsgBox";
import { Log } from "~/extensions/utils";
import { store } from "../../store/TaikyoStore";
import Loading from 'quasar/src/plugins/loading/Loading.js';
const log = Log.create("KaiyakuTaikyoButtonPanel");
export default defineComponent({
    name: "KaiyakuTaikyoButtonPanel",
    async setup() {
        const router = useRouter();
        let taikyoHtml = reactive({
            value: ""
        });
        let check = reactive({
            value: false
        });
        try {
            let result = await api.kaiyaku.loadTaikyoButtonText();
            taikyoHtml.value = result;
            if (store.taikyoEntity.taikyoKanryoDate) {
                check.value = true;
            }
        }
        catch (ex) {
            log.error("setup", ex);
            MsgBox.error(ex?.message ?? "エラーが発生しました。");
        }
        const taikyoComp = async () => {
            try {
                const dialogResult = await MsgBox.confirm("退去します。よろしいですか？");
                if (!dialogResult) {
                    return;
                }
                Loading.show();
                await store.updateForComplete();
                router.push({ name: "taikyo-complete" });
            }
            catch (ex) {
                log.error("taikyoComp", ex);
                MsgBox.error(ex?.message ?? "エラーが発生しました。");
                if (ex?.data?.code === "error.mail") {
                    router.push({ name: "taikyo-complete" });
                }
            }
            finally {
                Loading.hide();
            }
        };
        return {
            ...toRefs(store),
            taikyoComp,
            taikyoHtml,
            check
        };
    }
});
